import { styled, useTheme } from 'styled-components'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'

const Illustration = ({ imageSrc }: { imageSrc: string }) => {
  const theme = useTheme()
  const darkSuffix = theme.colorMode === 'dark' ? '-dark' : ''
  const isMobile = window.innerWidth < 768
  const mobileSuffix = isMobile ? '-mobile' : ''

  return (
    <Container>
      {/* <TextWidth>
        General locations of items recovered. Some parts could have come from different locations than shown
        </TextWidth> */}
      <ContentWidth>
        <Image
          src={require(`../MainComponent/illustration${darkSuffix}${mobileSuffix}.png`)}
          alt={"Illustration représentant les débris de l'avion retrouvés"}
        />
      </ContentWidth>
      <TextWidth>
        <Source>Source: Ministère des transports de Malaisie</Source>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div``

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  max-width: 1000px;
`

const Source = styled.div`
  font-size: 0.65em;
  line-height: 1.3em;
`

export default Illustration
